export interface Database {
  id?: string
  recordCount?: number
  participatedDate?: number
  lastDataUpdated?: number
  currentCollecting?: string
  currentTestCollecting?: string
  name?: LangStringYomi
  description?: LangString
  url?: string
  category?: string[]
  subCategory?: string[]
  metadataRights?: LangString
  apiType?: APIType
  thumbnailRights?: LangString
  contentsRightsType?: string
  contentsRights?: LangString
  contentsAccess?: string
  contentsType?: string
  image?: ImageSelection
  provider?: string
  providerUrl?: string
  notification?: LangString
  easyIIIF?: boolean
  rdfEnabled?: boolean
  rdfDate?: number
  diffFeatureUpdate?: boolean
  imageFeatureDate?: number
  textFeatureDate?: number
  scoreAdjust?: number
  permission?: Permission
  edit?: Edit
}

export type APIType =
  'ok' |
  'restricted' |
  'ng'
export const A_P_I_TYPE_DEF: EnumDef = Object.freeze({
  id: 'jps-a_p_i_type',
  c: {
    ok: {
      l: {
        ja: 'API取得可能',
        en: 'API Available'
      },
      d: {}
    },
    restricted: {
      l: {
        ja: '一部項目利用不可',
        en: 'Some Fiels Unavailable'
      },
      d: {}
    },
    ng: {
      l: {
        ja: 'API利用不可',
        en: 'API Unavailable'
      },
      d: {}
    }
  }
})
